export function codeMarkSpec() {
    return {
        code: {
            inclusive: false,
            parseDOM: [{ tag: "code" }],
            toDOM() {
                return ["code", 0];
            },
        },
    };
}
